import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { message } from "antd";
import { getToken } from "../../utils/getToken";

export const useGetSingleDiscountQuery = (id: string) => {
  const token = getToken();

  return useQuery({
    queryKey: ["useGetSingleDiscountQuery", id],
    queryFn: () =>
      axiosInstance
        .get(`discounts/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => res.data),

    // onError: (error: any) => {
    //   message.error(
    //     error?.response?.data?.message ||
    //       "An error occurred while fetching the discount."
    //   );
    // },
    enabled: !!token && !!id,
  });
};
